module.exports = __webpack_public_path__ + "media/fall_2024_sweepstakes/facebook-social-icon-2d3acebc.svg";